import $ from 'jquery';
import * as bootstrap from 'bootstrap';
import JSZip from 'jszip';
import pusher from "./components/pusher";

window.$ = window.jQuery = $;
window.JSZip = JSZip;
window.bootstrap = bootstrap;

document.addEventListener('DOMContentLoaded', init);

export const STATUS_CODE_NO_CONTENT = 204;

function init() {
  const goTopBtn = $('.back-to-top');

  /////////////////////////////////////////////////////
  // Show or hide the buttonToTop if page scrolling  //
  /////////////////////////////////////////////////////
  function trackScroll() {
    const scrolled = $(window).scrollTop();
    const coords = $(window).height();
    if (scrolled > coords) {
      goTopBtn.addClass('back-to-top-show');
    }
    if (scrolled < coords) {
      goTopBtn.removeClass('back-to-top-show');
    }
  }

  ////////////////////////////////
  // Scrolling page to the top  //
  ////////////////////////////////
  function backToTop() {
    if (window.scrollY > 0) {
      $('body,html').animate({scrollTop: 0}, 800);
    }
  }

  ///////////////////////////
  // Button click handling //
  ///////////////////////////
  $(document).on('click', '.back-to-top-show', function () {
    backToTop();
  });

  ///////////////////////////
  // Page scrolling handling //
  ///////////////////////////
  $(document).on('scroll', function () {
    trackScroll();
  });

  ////////////////////////////
  // Checking button status //
  ////////////////////////////
  trackScroll();

  ////////////
  // Pusher //
  ////////////
  pusher();
}

document.addEventListener('DOMContentLoaded', function() {
  const marqueeContainers = document.querySelectorAll('.marquee-container');

  marqueeContainers.forEach(container => {
    const marqueeText = container.querySelector('.marquee-text');

    function checkMarquee() {
      const containerWidth = container.offsetWidth;
      const textWidth = marqueeText.scrollWidth;

      if (textWidth > containerWidth) {
        marqueeText.style.animation = `marquee 25s linear infinite`;
      } else {
        marqueeText.style.animation = 'none';
      }
    }

    setTimeout(checkMarquee, 3000);

    window.addEventListener('resize', checkMarquee);
  });
});
